// @To-Do: Extract to shared library (https://nitrexgroup.atlassian.net/browse/QMU-5093)
/**
 * Strips the trailing slash from the url
 * @param url
 * @returns
 */
export function normalizeUrl<T extends string | undefined>(url: T): T {
  if (!url) {
    return url;
  }
  if (url.slice(-1) === '/') {
    return url.slice(0, -1) as T;
  }
  return url;
}
